import { useState, useCallback, useEffect } from 'react'

export default function useGetBlob(url: string) {
  const [data, setData] = useState<any>(null)

  const fetchUrl = useCallback(() => {
    if (url) {
      try {
        fetch(url)
          .then((response: any) => response.blob())
          .then((blob) => {
            setData(blob)
          })
      } catch (error) {
        console.error('getBlobVideo', error)
      }
    }
  }, [url])

  useEffect(() => fetchUrl(), [fetchUrl])

  return data
}
